<template>
  <svg class="svg-icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M256 544H224a32 32 0 1 1 0-64h32a32 32 0 1 1 0 64z m64-128H224a32 32 0 1 1 0-64h96a32 32 0 1 1 0 64z m96-128H224a32 32 0 1 1 0-64h192a32 32 0 1 1 0 64z m-96 384H224a32 32 0 0 1 0-64h96a32 32 0 0 1 0 64z m0 128H224a32 32 0 0 1 0-64h96a32 32 0 0 1 0 64z m480-256h-32a32 32 0 0 1 0-64h32a32 32 0 0 1 0 64z m0-128h-96a32 32 0 0 1 0-64h96a32 32 0 0 1 0 64z m0-128h-96a32 32 0 0 1 0-64h96a32 32 0 0 1 0 64z m0 384h-96a32 32 0 0 1 0-64h96a32 32 0 0 1 0 64z m0 128h-192a32 32 0 0 1 0-64h192a32 32 0 0 1 0 64zM608 224l-96 288h-160l256-288z m64 288l-256 288 96-288h160z"  /></svg>
</template>

<script>
export default {
  name: "SoilECIcon",
};
</script>
